import React from 'react'

import { FormattedMessage } from 'react-intl'

export const POSTBATTLE_TABS_CAPTIONS = {
    result: (
        <FormattedMessage
            id='postbattle_tabs.result'
            defaultMessage='Общий результат'
        />
    ),
    details: (
        <FormattedMessage
            id='postbattle_tabs.datails'
            defaultMessage='Отчёт о награде'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Tabs/constants.jsx